import React, { useState, useEffect, useContext } from 'react';
import './_timer.scss';
import { MessageContext } from '../../data/MessageContext';
import { utcDate } from '../../utils/helper';
import api from '../../api';
import { v4 } from 'uuid';

const Timer = ({ isTimerUpdate, onTimerEnd, timerData, updateTimer }: any) => {
    const [initialTimeInSeconds, setInitialTimeInSeconds] = useState(50);
    const [remainingTime, setRemainingTime] = useState(initialTimeInSeconds);
    const { messageData } = useContext(MessageContext)!;
    const [addTime, setAddTime] = useState<boolean>(false);
    const [lastEventLog, setLastEventLog] = useState<string[]>([]);

    const storedToken = localStorage.getItem('api_Token');
    const tenantId = localStorage.getItem('tenant_id');
    const currentDate = new Date().toISOString();

    const [isTimeExtended, setIsTimeExtended] = useState(false);

    const renderAddTime = () => {
        setIsTimeExtended(true);

        api.post(
            `${tenantId}/time`,
            {
                timestamp: currentDate,
            },
            {
                headers: {
                    Authorization: `Bearer ${storedToken}`,
                    'Content-Type': 'application/json',
                    correlationId: v4(),
                },
            },
        ).catch((err) => {
            setIsTimeExtended(false);
            console.log(err);
        });
    };

    useEffect(() => {
        if (timerData.csReleaseAt instanceof Date) {
            const currentDateTime: Date = utcDate(new Date());
            const expireTime: Date = utcDate(timerData.csReleaseAt);
            let timeDifferenceMillis: number =
                expireTime.getTime() - currentDateTime.getTime();
            setInitialTimeInSeconds(Math.floor(timeDifferenceMillis / 1000));
        }
    }, [timerData]);

    useEffect(() => {
        setRemainingTime(initialTimeInSeconds);
    }, [initialTimeInSeconds]);

    useEffect(() => {
        setRemainingTime(() => remainingTime);
    }, [remainingTime]);

    const handleCountdown = () => {
        setRemainingTime((prevTime) => (prevTime > 0 ? prevTime - 1 : 0));
    };

    const handleAddTime = () => {
        const timeToExtend = timerData.timeToExtend / 1000;
        setRemainingTime((prevTime) => prevTime + timeToExtend);
    };

    useEffect(() => {
        const intervalId = setInterval(handleCountdown, 1000);
        return () => clearInterval(intervalId);
    }, []);

    const minutes = Math.floor(remainingTime / 60);
    const seconds = remainingTime % 60;

    useEffect(() => {
        if (remainingTime <= 0) {
            onTimerEnd();
        }
    }, [remainingTime, onTimerEnd]);

    useEffect(() => {
        if (messageData.type === 'eu016' && !addTime) {
            setAddTime(true);
            handleAddTime();
        }
        // eslint-disable-next-line
    }, [messageData, addTime]);

    useEffect(() => {
        const newType = messageData.type ?? '';
        setLastEventLog((prev: string[]) => [...prev, newType]);
        if (lastEventLog.includes('eu016')) {
            messageData.timeExtended = true;
        }
        // eslint-disable-next-line
    }, [timerData, messageData]);

    return (
        <div className="remaining-outer-block">
            <p
                data-testid="remaining-time"
                className={`remaining-text ${
                    remainingTime < timerData.timeToExtend / 1000 &&
                    !timerData.timeExtended &&
                    messageData.type !== 'eu016' &&
                    !messageData.timeExtended &&
                    'add-extra-height'
                }`}
            >
                {`${minutes.toString().padStart(2, '0')}:${seconds
                    .toString()
                    .padStart(2, '0')}`}{' '}
                remaining for reply
            </p>
            {remainingTime > 0 &&
                remainingTime < timerData.timeToExtend / 1000 &&
                !timerData.timeExtended &&
                messageData.type !== 'eu016' &&
                !messageData.timeExtended && (
                    <button
                        disabled={isTimeExtended}
                        data-testid="add-time-button"
                        className="add-time-button"
                        onClick={renderAddTime}
                    >
                        + {timerData.timeToExtend / 1000} Seconds
                    </button>
                )}
        </div>
    );
};

export default Timer;
